import { getBase64 } from '../../helpers/upload/getBase64';
import { PYMENT } from '../../config/constants/contract';

const createContractScheme = async document => {
  const signerObj = async (signer, props, i) => {
    const body = {
      nombre: props.firstName,
      apellido: props.lastName,
      rut: props.rut,
      genero: props.gender,
      nacionalidad: props.nationality,
      estadoCivil: props.civilStatus,
      profesion: props.profession,
      direccion: props.address,
      comuna: props.commune,
      telefono: `${props.phonePrefix} ${props.phoneNumber.replace(/\s/g, '')}`,
      email: props.email,
      assets: {
        cedFront: document[`${signer}_${i}_cedFront`],
        cedBack: document[`${signer}_${i}_cedBack`],
      }
    };

    if (props.secondName) {
      body.segundoNombre = props.secondName;
    }

    if (props.mLastName) {
      body.segundoApellido = props.mLastName;
    }

    if (props.hasLegalPerson) {
      body.personaJuridica = {
        eud: props.companyCreationMethod,
        razon: props.businessName,
        giro: props.giro,
        rut: props.companyRol,
        direccion: props.address,
        comuna: props.commune,
        fechaPoder: new Date(props.dateOfconstitution).toISOString(),
        certificadoPoder: await getBase64(props.certificateFile.fileList[0])
      };
      if (!props.companyCreationMethod) {
        body.personaJuridica.notarioPoder = props.constitutionNotary;
      }
    }
    return body;
  };

  //base data ==============================================================================================
  const data = {
    formType: 'rentContract',
    sourceUrl: document.sourceUrl,
    fecha: new Date(document.dateSign).toISOString(),
    lugar: document.citySign,
    arrendador: await signerObj('lessor', document.lessor[0], 0),
    arrendatario: await signerObj('lessee', document.lessee[0], 0),
    inmueble: {
      tipo: document.typeOfHousing,
      direccion: document.homeAddress,
      comuna: document.homeCommune,
      certificadoDominio: await getBase64(document.domainCertificate.fileList[0]),
    },
    arriendo: {
      fecha: new Date(document.initialLeaseDate).toISOString(),
      duracion: `${document.contractDurationNumber} ${document.contractDurationRange}`,
      autorenovacion: document.autoRenewal,
      montoMensual: document.monthlyRent,
      tipoCambio: document.typeOfCurrency,
      periodoPago: document.paymentPeriod,
      montoGarantia: document.guaranteeAmount,
      prohibeAnimales: document.petBan,
      sancion: document.sanction,
    },
    tipoPago: document.paymentType,
    owner: {
      nombre: document.webpay_name,
      rut: document.webpay_rut,
      direccion: document.webpay_address,
      ciudad: document.webpay_city,
      email: document.webpay_email,
      telefono: document.webpay_phone,
    }
  };

  // extra lessee ==============================================================================================
  if (document.lessee.length && document.lessee[1]) {
    const arrendatarios = document.lessee.filter((_, i) => i > 0).map(async (signer, i) => {
      return await signerObj('lessee', signer, i + 1);
    });
    data.arrendatarios = await Promise.all(arrendatarios);
  }

  //optional codebtor ==============================================================================================
  if (document.hasCodebtor) {
    data.codeudor = await signerObj('codebtor', document.codebtor[0], 0);
  };

  //optional codebtor extra data ==============================================================================================
  if (document.codebtor.length && document.codebtor[0].firstName) {
    const codeudores = document.codebtor.filter((_, i) => i > 0).map(async (signer, i) => {
      return await signerObj('codebtor', signer, i + 1);
    });
    data.codeudores = await Promise.all(codeudores);
  };

  //optional contract data ==============================================================================================
  if (document.rentAdjustment) {
    data.arriendo.tipoReajuste = document.rentAdjustment;
    if (document.rentAdjustment === 'ipc') {
      data.arriendo.periodoReajuste = document.IPCAdjustment;
    }
    if (document.rentAdjustment === 'porcentaje') {
      data.arriendo.montoReajuste = parseFloat(document.percentAdjustment);
      data.arriendo.periodoReajuste = `cada ${document.readjustmentValue} ${document.readjustmentRange}`;
    }
  }
  if (document.finesType) {
    data.arriendo.tipoCambioMulta = document.finesType;
    data.arriendo.montoPenalizacion = document.finesAmount;
  }
  if (document.hasParking && document.parking.length) {
    data.inmueble.listaEstacionamiento = document.parking.map(number => Object.values(number).flat(1)[0].toString());
  }
  if (document.hasWarehouse && document.warehouse.length) {
    data.inmueble.listaBodega = document.warehouse.map(number => Object.values(number).flat(1)[0].toString());
  }

  //payment data ==============================================================================================
  if (document.payCommonExpenses) {
    data.arriendo.gastosComunes = document.payCommonExpenses;
  }
  if (document.webpay_nameCompany) {
    data.owner.nombreEmpresa = document.webpay_nameCompany;
    data.owner.giro = document.webpay_giro;
  };
  if (document.paymentType === PYMENT.TRANSFER) {
    data.cuentaPago = {
      nombre: document.holdersName,
      rut: document.holdersRut,
      email: document.notificationEmail,
      banco: document.bank,
      tipoCuenta: document.typeBankAccount,
      numeroCuenta: document.accountNumber,
    };
  };
  return data;
};

export default createContractScheme;